<template>
  <div>
    <div class="index">
      <div class="main-top">
        <!-- <div v-if="marquee_str" class="notice-box">
        <marquee :val="marquee_str" />
      </div> -->
        <div class="slide">
          <mySlide />
        </div>
        <swiper class="index-swiper" :options="swiperOptions">
          <swiper-slide v-for="item in bannerList" :key="item.index" class="swiper-slide">
            <img :src="item.file_url" class="carousel-img" alt="" srcset="">
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div>
        <div class="href-box flex flex-ac flex-jsb" :class="{'href-box-f':isFiex}">
          <div class="a-box flex flex-ac">
            <swiper ref="mySwiper" class="index-swiper" :options="hrefOptions">
              <swiper-slide v-for="(typeItem,index) in typeBoxList" :key="typeItem.id" class="href-slide">
                <a class="a-item" :class="{'a-item-active':index==searchForm.index}" @click="scrollToAnchor('section'+index,index)">
                  <img v-if="typeItem.img" :src="typeItem.img" alt="" srcset="" class="a-img">
                  <div class="n">{{ typeItem.type_name }}</div>
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div class="search-input flex flex-ac">
            <span class="label">价格</span>
            <input v-model="searchForm.minPrice" placeholder="请输入价格" class="input-price" />
            <span class="split">~</span>
            <input v-model="searchForm.maxPrice" placeholder="请输入价格" class="input-price" />
            <div class="btn-yellow" @click="getData">查询</div>
          </div>
        </div>
        <div class="center-box">
          <div v-for="(typeItem,index) in typeBoxList" :key="typeItem.id" :id="'section'+index" class="center">
            <div class="csgo-box">
              <div class="csgo-title">
                <div class="flex flex-ac flex-jc">
                  <img src="@/assets/images/title-label.png" />
                  <div class="t">{{ typeItem.type_name }}</div>
                  <img src="@/assets/images/title-label.png" />
                </div>
                <div v-if="typeItem.profile" class="des">{{ typeItem.profile }}</div>
              </div>
              <ul class="flex flex-w flex-jc">
                <li v-for="item in typeItem.box_list" :key="item.id" class="box-hover" @click="openbox(item.id)">
                  <div class="li-div">
                    <div class="bei1">
                      <img :src="item.img_main" class="img_main" />
                      <img :src="item.img_active" class="img_active" />
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="money-warp flex flex-jc flex-ac">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.price }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="about">
        <div class="info">
          <div>
            <h1>饰品导航 (CS:GO) 开箱网</h1>
            <p class="subtitle"> 在最好的开箱网购买带有精美 СS2 物品的箱子！ 你需要新的、很酷的物品吗CS2？购买你喜欢的箱子！ </p>
            <p class="more-info">在这里，你会发现令人羡慕的奖励！你还应该尝试像升级这样的有趣且独特的功能。</p>
            <div class="additional-table">
              <div class="additional-table__column">
                <h2>СS2 (CS:GO) 最佳箱子</h2>
                <p> 开箱时候里面会有不同价值的СS2物品。开箱前你可以查看箱子中有什么样的物品。 </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <myhomebot></myhomebot>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import marquee from "@/g-components/marquee.vue";
import _ from 'lodash'

export default {
  components: {
    myhomebot, marquee, mySlide
  },
  data() {
    return {
      input: '',
      searchForm: {
        minPrice: '',
        maxPrice: '',
        index: 0
      },
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000, // 自动切换时间间隔
          disableOnInteraction: false // 用户操作后是否禁止自动切换，默认为 true，设置为 false 将允许用户在触摸滑动后继续自动播放
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000, // 自动切换时间间隔
          disableOnInteraction: false, // 用户操作后是否停止自动切换，默认为true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true //允许分页点击跳转
        },
      },
      hrefOptions: {
        slidesPerView: 'auto'
      },
      isFiex: false,
      typeBoxList: [],
      bannerList: [],
      listSlide: [],
      active: [],
      userState: '',
      actBox: false,
      actTitle: '标题',
      actCont: '',
      activity: [],
      marquee_str: ''
    };
  },
  created() {
    this.getData()
    this.getboxList()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeCreate() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 672) {
        this.isFiex = true
      } else {
        this.isFiex = false
      }
      this.checkAnchor()
    },
    checkAnchor() {
      if (this.isClick) {
        return false
      }
      const anchors = this.typeBoxList.map((v, i) => 'section' + i)
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动位置
      const windowHeight = window.innerHeight; // 获取窗口高度
      anchors.forEach((anchor, i) => {
        const element = document.getElementById(anchor)
        if (element) {
          const elementPosition = element.getBoundingClientRect().top; // 获取元素顶部位置相对于视口的位置
          if (elementPosition < windowHeight) { // 如果元素在视口内或即将进入视口
            // console.log(`已滚动到 ${anchor} 和${i}`); // 处理你的逻辑，例如改变导航高亮等
            this.searchForm.index = i
            // this.$refs.mySwiper.$swiper.slideTo(i, 500, false)
            this.slideTo(i)
          }
        }
      });
    },
    slideTo(index) {
      const swiper = this.$refs.mySwiper.$swiper;
      _.debounce(() => {
        swiper.slideTo(index, 500, false)
      }, 500)(); // 300毫秒内只会执行一次slideTo
    },
    scrollToAnchor(anchorId, index) {
      if (this.searchForm.index == index) {
        return false
      }
      this.searchForm.index = index
      const element = document.getElementById(anchorId);
      if (element) {
        this.isClick = true
        element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
        this.isClick = false
      }
    },
    getData() {
      this.$doGet("/api/hall.Box/list", this.searchForm).then((res) => {
        this.typeBoxList = res.data
        this.searchForm.index = 0
      }).catch(() => { })
    },
    getboxList() {
      this.$doGet("/api/setting.Carousel/list").then((res) => {
        this.bannerList = res.data.list
      }).catch(() => { })
      // this.$doGet("/api/setting.Notice/list").then((res) => {
      //   this.marquee_str = res.data.list[0].desc
      // }).catch(() => { })
    },
    openbox(box_id) {
      this.$router.push({
        path: `/index/Openbox`,
        query: {
          box_id: box_id,
        },
      });
    },
    actInfo() {
      let _this = this;
      let param = {
        player_id: localStorage.getItem('id'),
        is_alter: 1
      };
      this.$axios.post("index/User/giveAboutRecharge", this.$qs.stringify(param)).then((res) => {
        let data = res.data.data;
        if (data.recharge_activity != undefined) {
          _this.actBox = true;
          _this.activity = data.recharge_activity;
          _this.actTitle = _this.activity.name;
          _this.actCont = "活动时间 2021-12-02 22:17 至 2021-12-25 22:17 单笔充值+送10%";
        }
      })
    },
    handleClose() {
      this.actBox = false;
    },

    fun(url) {
      let _this = this;
      this.$router.push({
        path: `/${url}`,
        query: {
          id: _this.activity.id
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  box-sizing: border-box;

  .main-top {
    width: 100%;
  }
  .notice-box {
    width: 100%;
    margin: 10px auto 10px;
    color: #fff;
  }
  .index-swiper {
    width: 100vw;
    margin: 0 auto;
    .carousel-img {
      height: 100%;
      width: 100%;
    }
  }
  .href-box {
    height: 60px;
    background: #2b2e3c;
    // padding: 0 30px;
    color: #fff;
    font-size: 15px;
    position: relative;
    &.href-box-f {
      width: 100%;
      position: fixed;
      top: 72px;
      left: 0;
      z-index: 22;
    }
    .a-box {
      max-width: 100%;
      overflow-y: hidden;
      overflow-x: auto;
      white-space: nowrap;
      .href-slide {
        width: auto;
      }
    }
    .a-item {
      line-height: 60px;
      display: inline-block;
      padding: 0px 30px;
      position: relative;
      color: #fff;
      &.a-item-active {
        color: #ffc400;
      }
      &.a-item-active::after {
        content: '';
        position: absolute;
        width: calc(100% - 60px);
        height: 2px;
        background: #ffc400;
        bottom: 0;
        left: 30px;
      }
      img {
        width: 16px;
        height: 17px;
        margin-right: 8px;
        display: inline-block;
        vertical-align: middle;
      }
      .n {
        display: inline-block;
      }
    }
    .search-input {
      padding-right: 30px;
      min-width: 370px;
      .input-price {
        width: 100px;
        text-align: center;
        background: #ffffff;
        border-radius: 4px;
        line-height: 24px;
        border: 0;
      }
      .label {
        margin-right: 12px;
      }
      .btn-yellow {
        margin-left: 24px;
      }
      .split {
        margin: 0 8px;
      }
    }
  }
  .center-box {
    margin: 0 auto;
    .center {
      margin: 0 auto;
      max-width: 1500px;
    }
    .csgo-box {
      padding-top: 120px;
      .csgo-title {
        margin-bottom: 20px;
      }
    }
  }
  .about {
    padding: 60px 5%;
    order: 20;
    text-align: center;
    background: #20222b;
    .info {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      h1 {
        font-size: 28px;
        letter-spacing: 0;
        color: #fbc300;
        margin-bottom: 20px;
        font-weight: 700;
      }
      p {
        margin-left: auto;
        margin-right: auto;
      }
      p.subtitle {
        margin-bottom: 30px;
        font-size: 18px;
        font-weight: 400;
        max-width: 940px;
        color: #fff;
        width: 100%;
      }
      p.more-info {
        font-weight: 700;
        font-size: 22px;
        margin-bottom: 30px;
        max-width: 1100px;
        color: #fff;
      }
    }
    .additional-table {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }
    .additional-table__column {
      max-width: 1100px;
      color: #a3abbf;
    }
  }
}
</style>
<style>
.index-swiper .swiper-pagination-bullet {
  background: #ffffff;
  opacity: 0.3;
}
.index-swiper .swiper-pagination-bullet-active {
  background: #ffffff;
  opacity: 1;
}
/* 整个滚动条 */
.a-box ::-webkit-scrollbar {
  width: 6px; /* 滚动条的宽度 */
  height: 6px; /* 滚动条的高度 */
}

/* 滚动条轨道 */
.a-box ::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道颜色 */
}

/* 滚动条滑块 */
.a-box ::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 滑块悬停时 */
.a-box ::-webkit-scrollbar-thumb:hover {
  background: #555; /* 滑块悬停时的颜色 */
}
.index-swiper {
  --swiper-navigation-size: 24px;
  --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
}
</style>
